import { Box } from "@chakra-ui/react";

// import { useIndividualCompliance } from "contexts/individual-compliance-context";
import { Paragraph3 } from "ui/typography";

import { ComplianceTrailTimeline } from "./ComplianceTrailTimeline";
import { IndividualDetailsProps } from "./types";

const START_INDEX = 0;
export const IndividualComplianceTrail = (props: IndividualDetailsProps) => {
  const { individual } = props;

  return (
    <>
      {individual?.adminKycComment?.length > START_INDEX ? (
        <ComplianceTrailTimeline
          complianceTrails={
            individual.adminKycComment ? individual.adminKycComment : []
          }
        />
      ) : (
        <Box>
          <Paragraph3
            lineHeight="22.4px"
            textColor="#718096"
          >
            Nothing to see here yet.
          </Paragraph3>
        </Box>
      )}
    </>
  );
};
